import { cn } from "@/lib/utils";

import type { BlogPostType } from "../../types";

type PostProps = BlogPostType & { className?: string };

export default function Post({ className, coverImage, title, url }: PostProps) {
  return (
    <article
      className={cn(
        'group relative aspect-[325/227] overflow-hidden rounded-[14px] after:absolute after:inset-0 after:bg-gradient-to-b after:from-16% after:from-black-rock/0 after:to-black-rock after:content-[""] md:aspect-[553/480] md:w-1/2',
        className
      )}
    >
      <img
        alt={title}
        className="absolute inset-0 object-cover transition-transform group-hover:scale-110"
        src={coverImage.data.attributes.url}
      />
      <div className="relative z-2 flex size-full items-end p-5">
        <h2 className="font-medium text-14 leading-[1.43em] md:text-30">
          <a
            className="link-overlay"
            href={url}
            rel="noopener noreferrer"
            target="_blank"
          >
            {title}
          </a>
        </h2>
      </div>
    </article>
  );
}
